<template>
	<div class="header">
		<div class="container-fluid">
			<div class="mt-4">
				<div class="card">
					<div class="card-body">
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb">
								<li class="breadcrumb-item fw-bolder">Master Data</li>
								<li class="breadcrumb-item">Role</li>
							</ol>
						</nav>
					</div>
				</div>
			</div>
			<div class="card mt-5">
				<div class="card-header">
					<h4 class="card-header-title">Role</h4>
					<!-- <b-button v-b-modal.modal-1 variant="primary" @click="isAdd = true">
            <span class="fe fe-file-plus"></span>
            Role
          </b-button> -->
				</div>
				<vue-good-table
					:line-numbers="true"
					:columns="columns"
					:rows="list.data"
					:sort-options="{
						enabled: false,
					}"
					:total-rows="10"
					:pagination-options="{
						enabled: true,
						mode: 'pages',
						position: 'bottom',
						perPage: 10,
						perPageDropdown: [10, 50, 100],
						dropdownAllowAll: false,
						setCurrentPage: 1,
						nextLabel: 'next',
						prevLabel: 'prev',
						rowsPerPageLabel: 'Rows per page',
						ofLabel: 'of',
						pageLabel: 'page',
						allLabel: 'All',
					}"
					style-class="vgt-table border-0 table"
					@on-page-change="onPageChange"
					@on-per-page-change="onPageChange"
				>
					<div slot="emptystate" class="text-center font-size-14">No data available</div>
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'action'">
							<b-button
								class="no-wrap btn-pill ml-2"
								variant="warning"
								size="sm"
								@click="updateData(props.row)"
								v-if="canEdit"
							>
								<span class="fe fe-edit"></span>
							</b-button>
							<b-button
								class="no-wrap ml-2"
								variant="danger"
								style="margin-left: 5px"
								size="sm"
								@click="deleteData(props.row.id)"
								v-if="canDelete"
							>
								<span class="fe fe-trash-2"></span>
							</b-button>
						</span>
					</template>
				</vue-good-table>
			</div>

			<b-modal id="modal-1" hide-footer title="Role Form" @hide="closeNotification($event)">
				<form @submit.prevent="save()">
					<div class="form-group">
						<label>Role Name <span class="text-danger">*</span></label>
						<input
							type="text"
							v-model="role.roles_name"
							class="form-control"
							placeholder="Role Name"
							v-validate="'required'"
							name="Role Name"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Role Name')">{{ errors.first('Role Name') }}</span>
					</div>
					<div class="form-group">
						<label>Description <span class="text-danger">*</span></label>
						<textarea
							type="text"
							v-model="role.description"
							class="form-control"
							placeholder="Description"
							v-validate="'required'"
							name="Description"
						/>
						<span class="text-sm text-danger" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
					</div>
					<div class="row gap-4 border-bottom mb-2">
						<b>Role Permission</b>
					</div>
					<div class="row gap-4">
						<div class="col">
							<div class="mb-2">Menu</div>
							<div v-for="menu in menus" :key="menu.id">
								<i :class="`fe fe-${menu.icon}`"></i>
								{{ $t(menu.i18n) || menu.name }}
								<div v-for="child in menu.childs" :key="child.id" class="ml-4">
									{{ $t(child.i18n) || child.name }}
								</div>
							</div>
						</div>
						<div class="col">
							<div class="d-flex mb-2">
								<span class="mr-4">Read</span>
								<span class="mr-4">Create</span>
								<span class="mr-4">Update</span>
								<span class="mr-4">Delete</span>
							</div>
							<div v-for="menu in menus" :key="menu.id">
								<div class="d-flex" v-if="menu.childs.length < 1">
									<b-checkbox :name="`read-${menu.id}`" v-model="authorization[menu.id].read" class="mr-5"></b-checkbox>
									<b-checkbox :name="`create-${menu.id}`" v-model="authorization[menu.id].create" class="mr-5"></b-checkbox>
									<b-checkbox :name="`update-${menu.id}`" v-model="authorization[menu.id].update" class="mr-5"></b-checkbox>
									<b-checkbox :name="`delete-${menu.id}`" v-model="authorization[menu.id].delete" class="mr-5"></b-checkbox>
								</div>
								<div v-else>&nbsp;</div>
								<div v-for="child in menu.childs" :key="child.id">
									<div class="d-flex" v-if="authorization[child.id]">
										<b-checkbox :name="`read-${child.id}`" v-model="authorization[child.id].read" class="mr-5"></b-checkbox>
										<b-checkbox :name="`create-${child.id}`" v-model="authorization[child.id].create" class="mr-5"></b-checkbox>
										<b-checkbox :name="`update-${child.id}`" v-model="authorization[child.id].update" class="mr-5"></b-checkbox>
										<b-checkbox :name="`delete-${child.id}`" v-model="authorization[child.id].delete" class="mr-5"></b-checkbox>
									</div>
									<div v-else>&nbsp;</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group float-end">
						<button class="mt-4 btn btn-outline-light mr-2" type="button" @click="confirmAndCloseModal()">Cancel</button>
						<button class="mt-4 btn btn-primary" type="submit" v-if="isLoading == false">Save</button>
						<button class="mt-4 btn btn-primary" type="button" disabled v-else>
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Loading...
						</button>
					</div>
				</form>
			</b-modal>
		</div>
	</div>
</template>

<script>
	import { authorize } from '@/utils/authorize';
	export default {
		computed: {
			list() {
				return this.$store.getters['role/list'];
			},
			listMenu() {
				return this.$store.getters['role/listMenus'];
			},
		},
		data() {
			return {
				body: {
					page: 1,
					limit: 100,
				},
				isAdd: true,
				isLoading: false,
				columns: [
					{
						label: 'Role Name',
						field: 'roles_name',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Description',
						field: 'description',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
					{
						label: 'Action',
						field: 'action',
						thClass: 'table-header no-wrap w-40 text-muted font-weight-bold',
						tdClass: 'no-wrap color-secondary align-middle',
					},
				],
				role: {
					id: '',
					roles_name: '',
					description: '',
				},
				menus: [], // Hierarchical menu structure for looping
				authorization: {}, // Checkbox states for each menu_id
				canAdd: false,
				canEdit: false,
				canDelete: false,
			};
		},

		async mounted() {
			await this.getList();
			this.canAdd = await authorize('/role', 'create');
			this.canEdit = await authorize('/role', 'update');
			this.canDelete = await authorize('/role', 'delete');
		},
		methods: {
			// for preformating menu data
			processMenus(menusData, roleMenusForUpdate = []) {
				const tempAuthorization = {};

				const existingRoleMenuAuthMap = new Map();
				if (Array.isArray(roleMenusForUpdate)) {
					roleMenusForUpdate.forEach((roleMenu) => {
						if (roleMenu.id && roleMenu.role_menus && Array.isArray(roleMenu.role_menus.authorization)) {
							existingRoleMenuAuthMap.set(roleMenu.id, roleMenu.role_menus.authorization);
						}
					});
				}

				const initializeAuthorization = (menus) => {
					if (!Array.isArray(menus)) return;
					menus.forEach((menu) => {
						const menuAuthorization = existingRoleMenuAuthMap.has(menu.id) ? existingRoleMenuAuthMap.get(menu.id) : [];

						tempAuthorization[menu.id] = {
							read: menuAuthorization.includes('read'),
							create: menuAuthorization.includes('create'),
							update: menuAuthorization.includes('update'),
							delete: menuAuthorization.includes('delete'),
						};
						if (menu.childs && menu.childs.length > 0) {
							initializeAuthorization(menu.childs);
						}
					});
				};

				initializeAuthorization(menusData);

				this.menus = JSON.parse(JSON.stringify(menusData));
				this.authorization = tempAuthorization;
			},

			//convert checkbox state to array
			getAuthorizationArray(menuId) {
				const auth = [];
				const perms = this.authorization[menuId];
				if (perms) {
					if (perms?.read) auth.push('read');
					if (perms?.create) auth.push('create');
					if (perms?.update) auth.push('update');
					if (perms?.delete) auth.push('delete');
				}
				return auth;
			},

			async updateData(props) {
				this.isAdd = false;
				await this.$store.dispatch('role/GET_DETAIL', props.id);
				const fetchedRole = { ...this.$store.getters['role/detail'] };
				this.role = {
					id: fetchedRole.id,
					roles_name: fetchedRole.roles_name,
					description: fetchedRole.description,
				};
				this.processMenus(this.listMenu, fetchedRole.menus || []);
				this.$bvModal.show('modal-1');
			},

			reset() {
				this.role = {
					id: '',
					roles_name: '',
					description: '',
				};
			},

			getList() {
				this.$store.dispatch('role/GET_LIST', this.body);
			},

			async save() {
				this.$validator.validateAll().then(async (res) => {
					if (!res) return false;

					try {
						this.isLoading = true;

						const authorizationPayload = Object.keys(this.authorization).map((menuId) => {
							return {
								menu_id: parseInt(menuId),
								authorization: this.getAuthorizationArray(menuId),
							};
						});

						const payload = {
							roles_name: this.role.roles_name,
							description: this.role.description,
							authorization: authorizationPayload,
						};

						if (!this.isAdd) {
							payload.id = this.role.id;
						}

						if (this.isAdd) {
							await this.$store.dispatch('role/CREATE_DATA', payload).then(() => {
								this.$swal('Saved', 'Your input has been saved', 'success').then(async () => {
									await this.getList();
								});
							});
						} else {
							await this.$store.dispatch('role/UPDATE_DATA', payload).then(() => {
								this.$swal('Saved', 'Your input has been updated', 'success').then(async () => {
									await this.getList();
								});
							});
						}
					} catch (error) {
						console.error('Error saving data:', error);
						this.$swal('Error', 'Error while add data', 'error');
					}
					this.$bvModal.hide('modal-1');
					this.isAdd = true;
					this.isLoading = false;
					this.reset();
				});
			},

			closeNotification(evt) {
				if (evt.trigger === 'backdrop') {
					evt.preventDefault();
				}
				if (evt.trigger === 'headerclose') {
					evt.preventDefault();
					this.confirmAndCloseModal();
				}
			},

			confirmAndCloseModal() {
				this.$swal({
					title: 'Confirm Close?',
					text: 'Are you sure you want to close this page?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes',
					cancelButtonText: 'No',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$bvModal.hide('modal-1');
						this.reset();
					} else {
						console.log('Modal close cancelled from button.');
					}
				});
			},

			deleteData(id) {
				this.$swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes, delete it!',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.$store
							.dispatch('role/DELETE_DATA', id)
							.then(async () => {
								await this.getList();
								this.$swal('Deleted!', 'Your data has been deleted', 'success');
							})
							.catch(() => {
								this.$swal('Error', 'Error while delete data', 'error');
							});
					}
				});
			},

			filterPage() {},
			sorting() {},

			async onPageChange(payload) {
				this.body.limit = payload.currentPerPage;
				this.body.page = payload.currentPage;
				await this.getList();
			},
		},
	};
</script>
